module.exports = __webpack_public_path__ + "static/media/connect.42096baf.svg";